<template>
    <div class="wrapper">
        <div class="profile-container">
            <template v-if="profile">
                <div class="profile-wrapper profile-header-container">
                    <div class="profile-map-wrapper">
                        <div class="profile-map" ref="profile_map"></div>
                    </div>
                    <div class="highlight-box noselect">
                        <div class="profile-image">
                            <div>
                                <img
                                    v-if="profile_image.file"
                                    :src="profile_image.file.url"
                                    alt="">
                                <img v-else src="@/assets/images/profileLight.svg">

                                <span v-if="me" @click="add_profile_img" class="add-image-overlay">
                                    <h2>Bearbeiten</h2>
                                </span>
                            </div>
                        </div>
                        <div class="highlight-box-main-content">
                            <h2 class="profile-title">{{profile.name}}</h2>
                            <span class="subtext">{{$t(profile.className)}}</span>
                            <span  v-if="!me && eligableForRequest">
                                <stb-button v-if="alreadySent" disabled name="Anfrage gesendet" />
                                <stb-button v-else  @click.native="$modal.show('send_request')" name="Anfrage senden"/>
                            </span>
                        </div>
                        <div class="highlight-box-bottom-content" v-if="profile">
                            <p>{{$t('phone')}} <a :href="'tel:' + profile.phone">{{profile.phone}}</a></p>
                            <p>{{$t('mail')}} <a :href="'mailto:' + profile.mail">{{profile.mail}}</a></p>
                            <p>{{$t('address')}} <a>{{profile.address | formatAddress(module)}}</a></p>
                            <p v-if="employerId">Hinzugefügt von <router-link :to="'/employers/' + employerId">{{employerName}}</router-link></p>
                        </div>
                    </div>
                </div>

                <div class="profile-wrapper" v-if="me || (files && files.length)">
                    <h1>Dokumente</h1>
                    <div class="profile-files">
                        <template
                            v-for="file in files"
                        >
                            <a :href="get_file_url(file)" target="_blank" style="outline: none">
                                <stb-card
                                    :title="file.name"
                                    :subtitle="format_filesize(file.size)"
                                    icon="file"
                                >
                                    <stb-delete v-if="me" @click="delete_file(file, $event)"></stb-delete>
                                </stb-card>
                            </a>
                        </template>

                        <div class="add-button" @click="add_file" v-if="me">
                            <img src="@/assets/images/plusIcon.svg">
                            <span class="profile-file-title">Datei hinzufügen</span>
                        </div>
                    </div>
                </div>
                <div class="profile-wrapper">
                    <h1 v-if="module == 'applicants'">Über mich</h1>
                    <h1 v-else>Über uns</h1>
                    <div class="about-me-wrapper">
                        <div class="profile-text-container">
                            <template v-if="profile.description">
                                <p>
                                {{profile.description}}
                                </p>
                            </template>
                            <template v-else>
                                <p class="subtext">Keine Beschreibung verfügbar.</p>
                            </template>
                            
                        </div>
                        <div class="profile-images">
                            <div
                                class="profile-image-preview"
                                v-for="(image, imageIndex) in images">
                                <img
                                    v-if="image.file"
                                    :src="image.file.url()"
                                    alt=""
                                    :key="imageIndex"
                                    @click="galleryIndex = imageIndex"
                                >
                                
                                <stb-delete v-if="me" @click="delete_image(image)"></stb-delete>
                            </div>
  
                            <div class="profile-image-preview add-button" @click="add_image" v-if="me">
                                <img src="@/assets/images/plusIcon.svg">
                                <span class="profile-file-title">Bild<br>hinzufügen</span>
                            </div>
                        </div>
                    </div>
                </div>
                <div style="max-width: 17.5em" v-if="me">
                    <div class="add-button" @click="$modal.show('content_editor')">
                        <img src="@/assets/images/plusIcon.svg">
                        <span class="profile-file-title">Inhalte bearbeiten</span>
                    </div>
                    <!--
                    <div class="add-button" @click="$modal.show('change_password')">
                        <span class="profile-file-title">Passwort ändern</span>
                    </div>
                    -->

                    <div class="add-button" @click="edit_profile()">
                        <img src="@/assets/images/plusIcon.svg">
                        <span class="profile-file-title">Profil bearbeiten</span>
                    </div>

                </div>

            </template>
            <div v-else>
                <h1>Unbekannter Nutzer</h1>
                <p>Leider wurde der angefragte Nutzer nicht gefunden.</p>
            </div>
        </div>
        <input type="file" ref="profile_image" style="display: none" @change="upload_profile_image" accept="image/*">
        <input type="file" ref="image" style="display: none" @change="upload_image" accept="image/*">
        <input type="file" ref="file" style="display: none" @change="upload_file">

        <modal name="send_request" title="Anfrage senden">
            Wollen Sie eine Anfrage senden?

            <div slot="footer" >
                <stb-button name='Anfrage senden' @click.native="send_request()" />
            </div>
        </modal>
        <modal name="content_editor" class="modal_content_editor" title="Inhalte bearbeiten">
            <template v-if="profile">
                <!--
                <b>Telefonnummer</b><br>
                <input type="text" class="input" v-model="profile.phone">
                <br><br>
                <b>E-Mail-Adresse</b><br>
                <input type="text" class="input" v-model="profile.mail">
                <br><br>
                <b>Adresse</b><br>
                <input type="text" class="input" v-model="profile.address">
                <br><br>
                <b>Beschreibung</b><br>
                
                -->
                <textarea class="textarea description" name="description" id="" v-model="editor.description" placeholder="Beschreibung …">
                </textarea>
            </template>

            <div slot="footer" >
                <stb-button name="Speichern" @click.native="save_content" />
            </div>
        </modal>

        <modal name="profile_editor" title="Profil bearbeiten">
            
            <template v-if="edited_profile">
                <h2 v-if="module == 'applicants'">Dein Name</h2>
                <h2 v-else>Unternehmensname</h2>
                <br>
                <input v-model="edited_profile.name" type="text" class="input" placeholder="Max Mustermann">
                <br>
                <br>
                


                <h2>Email</h2>
                <br>
                <input v-model="edited_profile.mail" type="email" class="input" placeholder="max@mustermann.de">
                <br>
                <br>

                <h2>Phone</h2>
                <br>
                <input v-model="edited_profile.phone" type="phone" class="input" placeholder="0171 123 4567">
                <br>
                <br>
            </template>



            <h2>Adresse bearbeiten</h2><br>
            <p>Die Adresse hilft dabei, besser gefunden zu werden. <span v-if="module == 'applicants'"> Als Bewerber wird deine genaue Adresse verborgen, sodass niemand deinen genauen Standpunkt einsehen kann.</span></p><br>
            <input v-model="edit_address.name" type="text" class="input" v-autocomplete="edit_address" placeholder="Max-Mustermann-Str. 1, 18055 Rostock">
            <br>
            <br>
            
            <p>Um Ihr Profil unwiderruflich zu löschen, nutzen sie folgenden Button:</p>
            <br>

            <stb-button @click.native="remove_profile()" class="profile-file-title" type="danger" name="Profil löschen"/>
            

            <div slot="footer" >
                <stb-button name="Abbrechen" type="secondary"  @click.native="$modal.close('profile_editor')" />
                <stb-button name="Speichern" @click.native="save_profile" />
            </div>

        </modal>

        <modal name="profile_remove_file" title="Datei löschen">
            Sind Sie sich sicher, dass Sie diese Datei löschen wollen?

            <div slot="footer">
                <stb-button
                    name="Ja, löschen"
                    @click.native="$modal.close('profile_remove_file')"
                />
            </div>
        </modal>

        <gallery :images="galleryImages" :index="galleryIndex" @close="index = null"></gallery>
    </div>
</template>

<style lang="scss">

// .modal_content_editor .modal__content {
//     min-width: 35em;
// }

.profile-header-container {
    background-color: $light-bg-color;
    @include border-radius();
    @include drop-shadow();
    overflow: hidden;
}

.profile-map-wrapper {
    padding-bottom: 33%;
    background-color: $dark-grey;
    overflow: hidden;
    position: relative;
}

.profile-map-wrapper .profile-map {
    position: absolute;
    width: 100%;
    height: calc(100% + 15px);
    top: 0px;
    left: 0px;
}

.profile-map-wrapper:after {
    content: "";
    position: absolute;
    top: 100%;
    left: 0px;
    width: 120%;
    height: 30%;
    transform-origin: 0% 0%;
    transform: rotate(-4deg);
    background-color: $light-bg-color;
    content: "";
}

.highlight-box {
    width: 100%;
    position: relative;
    text-align: center;
    margin-top: -14%;
    padding: 1.3em 2em;
}

.highlight-box .profile-title {
    font-size: 1.6em;
}

.highlight-box .subtext {
    font-size: 1em;
    margin-bottom: 0.5em;
}

.highlight-box .profile-image {
    max-width: 170px;
    width: 40%;
    overflow: hidden;
    display: inline-block;
    /*
    background-color: $dark-grey;
    @include drop-shadow();
    */
    border-radius: 10em; 
    margin-bottom: 0.9em;
}

.highlight-box .profile-image div {
    position: relative;
    width: 100%;
    padding-bottom: 100%;
}

.highlight-box .profile-image img {
    width: 100%;
    height: 100%;
    top: 0px;
    left: 0px;
    position: absolute;
    object-fit: cover;
}

.highlight-box-bottom-content {
    width: 100%;
    display: flex;
    flex-wrap: wrap;
    margin-top: 2em;
    justify-content: space-between;
    align-content: center;
}

.highlight-box-bottom-content p {
    margin-bottom: 0em;
    padding: 0em 0.5em;
    min-width: 140px;
    text-align: center;
    white-space: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
}

.highlight-box-bottom-content p a {
    opacity: 1;
    color: $secondary-text-color;
    text-decoration: none;
    font-size: inherit;
    display: inline;
    padding: 0;
    margin: 0;
    font-weight: 300;
    line-height: inherit;
    word-break: nowrap;
    text-overflow: ellipsis;
    overflow: hidden;
    width: auto;

}

.profile-files a {
    opacity: 1;

    .nameCardProfile {
        transition: 0.2s ease;
        position: relative;
        &:hover {
            transform: translateY(-3px);
        }
    }
}

.add-image-overlay {
    position: absolute;
    top: 0px;
    left: 0px;
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: center;
    align-content: center;
    align-items: center;
    background: rgba(255,255,255,0.6);
    opacity: 0;
    cursor: pointer;

    &:hover {
        opacity: 1;
    }
}

@media screen and (max-width: 1190px) {
    .highlight-box {
        padding: 1em 1em;
    }

    .highlight-box-bottom-content {
        justify-content: center;
    }

    .highlight-box {

        margin-top: -25%;
    }
}


@media screen and (max-width: 1260px) {
    .highlight-box-bottom-content p {
        padding: 0.2em 0.7em;
    }


    .profile-map-wrapper {
        padding-bottom: 80%;
    }

}
.profile-container h1 {
    margin-top: 1.3em;
    margin-bottom: 0.2em;
}


.profile-files {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
    align-items: stretch;
    align-content: stretch;
}

.profile-files .nameCard {
    margin-right: 1em;
}

.profile-files .nameCardProfile {
    margin-top: 0;
}

.about-me-wrapper {
    display: flex;
    /*flex-wrap: wrap;*/
    width: 100%;
    align-items: flex-start;
    align-content: flex-start;
    justify-content: space-between;

}

.profile-text-container {
    background-color: $light-bg-color;
    flex-grow: 3;
    @include border-radius();
    @include drop-shadow();
    padding: 1.5em;
    margin-bottom: 1.5em;
    min-height: 200px;
    min-width: 300px;
    max-width: 550px;
    flex-basis: 100px;
}

.profile-text-container p {
    outline: none;
}



.profile-images {
    /*min-width: 500px;*/
    flex-basis: 100px;
    flex-grow: 2;
    margin-left: 1.5em;
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-start;
}

.profile-image-preview {
/*    min-width: calc(50% - 0.75em);
    width: calc(50% - 0.75em);*/
/*    padding-bottom: 45%;*/
    cursor: pointer;
    height: 200px;
    min-width: 50px;
    position: relative;
    margin-right: 1.5em;
    margin-bottom: 1.5em;
    background: white;
    
    @include drop-shadow();
    // overflow: hidden;

    &:hover {
        @include hover();
    }
}


@media (max-width: 1060px) {
  .profile-image-preview {
    height: auto;
    width: 100%;

    img {
        height: auto;
        width: 100%;
    }
  }
}


.profile-image-preview img {
/*    position: absolute;
    width: 100%;*/
    height: 100%;
    @include border-radius();
    /*object-fit: cover;*/
}

.profile-image-preview.add-button {
    min-width: 150px;
}

.profile-files .add-button span {
    padding-right: 2em;
}

@media screen and (max-width: 1160px) {
    .about-me-wrapper {
        flex-wrap: wrap;
    }
    .profile-text-container {
        width: 100%;
        min-width: 100%;
    }

    .profile-images {
        width: 100%;
        margin-left: 0em;
    }
}


.profile-images .add-button {
    flex-wrap: wrap;
    text-overflow: center;
    justify-content: center;
    align-content: center;
    align-items: center;
    margin-right: 0em;
    max-width: 100%;
    overflow: hidden;
    padding-bottom: 0em;
}
.profile-images .add-button span {
    width: 100%;
    text-align: center;
    margin-bottom: 1.5em;
}

.profile-images .add-button img {
    position: relative;
    width: 30%;
    min-width: 30%;
    margin-bottom: 1em;
    height: auto;
}

</style>

<script>
import {
    create_map,
    update_markers,
} from '@/utils/map'
import Parse from 'parse'
import ParseFile from '@/utils/parse-file'
import loadUser from '@/utils/load-user'
import _ from 'lodash'
import {toast} from '@/utils/interactions'

export default {
    props: ['module'],
    static() {
        return {
            map: null,
            markers: {},
        };
    },
    data() {
        return {
            me: false,
            profile: null,
            edited_profile: null,
            images: [],
            files: [],
            alreadySent: false,
            employerId: false,
            edit_address: {
                obj: {},
                name: ""
            },
            profile_image: false,
            galleryIndex: null,
            /*[
                {
                    name: 'Steuerbüro Funk',
                    id: 'DKGeXiVFtg',
                },
            ],*/

            notifications: [
                {
                    title: 'Steuerbüro Funk - Neue Anfrage',
                    subtitle: 'Eben gerade',
                    description: 'Ein neuer Steuerberater interessiert sich für dich.',
                },
                {
                    title: 'Max - Neuer Nutzer',
                    subtitle: 'Eben gerade',
                    description: 'Ein neuer Nutzer ist hinzugekommen.',
                },
                {
                    title: 'Emily - Neuer Nutzer',
                    subtitle: 'Eben gerade',
                    description: 'Ein neuer Nutzer ist hinzugekommen.',
                },
                {
                    title: 'Miriam - Neuer Nutzers',
                    subtitle: 'Eben gerade',
                    description: 'Ein neuer Nutzer ist hinzugekommen.',
                },
            ],

            //
            editor: {
                description: '',
            },
        };
    },

    computed: {
        can_add_reference() {
            return this.$shared.user.type === 'Employer';
        },

        galleryImages() {
            return this.images.map((img) => {
                return img.file.url();
            })
        },
        eligableForRequest() {
            if (this.$shared.user.type === 'Employer' && this.module == "employers") {
                return false;
            }
            if (this.$shared.user.type === 'Applicant' && this.module == "applicants") {
                return false;
            }
            return true;
        },

        employerName() {
            if (this.profile && this.profile.employer) {
                return this.profile.employer.get("name");
            }

            return "";
        },
    },
    mounted() {
        var id = this.$route.params.id;
        // is it my own account?

        var user = this.$api.user();
        if ((this.$shared.user.profile && this.$shared.user.profile.objectId == id) || this.$shared.admin) {
            this.me = true;
        }
        var relation = this.$shared.user.profile.$p.relation("connections");
        relation.query().find().then((connections) => {
            if (connections) {
                for (var i = 0; i < connections.length; i++) {
                    if(connections[i].id == this.$route.params.id) {
                        this.alreadySent = true;
                        return;
                    }
                }
            }
        })
        this.$api[this.module].get(id).then((profile) => {
            this.profile = profile;
            if (this.profile) {
                if (this.module == 'employers') {

                    this.$nextTick(() => {

                        var center = {
                            lat: this.profile.position.latitude,
                            lng: this.profile.position.longitude,
                        }
                        this.map = create_map(this.$refs.profile_map, center, 10);
                        update_markers(this.map, this.markers, [this.profile]);
                    });
                } else {

                    var user = this.profile.$p.get("user").fetch((user) => {
                        this.profile.employer = user.get("employer");
                        this.employerId = user.get("employer").id;
                    });
                }
                // if (this.module == 'applicants') {
                //     var references = this.profile.$p.get('references') || [];
                //     if (references && references.length) {
                //         this.references = references;
                //     }
                // }
                var files = this.profile.$p.get('files') || [];
                if (files && files.length) {
                    this.files = files.map((f) => ParseFile(f), files);
                }
                var images = this.profile.$p.get('images') || [];
                if (images && images.length) {
                    this.images = images.map((f) => ParseFile(f), images);
                }

                var profile_image = this.profile.profile_image;
                if (profile_image && profile_image != "") {
                    this.profile_image = ParseFile(profile_image);
                }

                // field content editor fields
                this.editor.description = this.profile.description;
                this.profile.description = this.editor.description;
            }
        });
    },
    methods: {
        add_file() {
            this.$refs.file.click();
        },
        add_image() {
            this.$refs.image.click();
        },

        add_profile_img() {
            this.$refs.profile_image.click();
        },
        upload_file() {
            var files = this.$refs.file.files;
            if (!files || !files.length) {
                return;
            }
            var input_file = files[0];
            if (!input_file || !input_file.name) {
                return;
            };
            let loader = this.$loading.show();
            var file = ParseFile(input_file);
            file.$save().then((file) => {
                this.profile.$p.addUnique('files', file);
                this.profile.$save().then((profile) => {
                    this.profile = profile;
                    var files = profile.$p.get('files') || [];
                    this.files = files.map((f) => ParseFile(f), files);
                    toast('Die Datei wurde erfolgreich hochgeladen.');
                }).catch((err) => {
                    toast('Es ist ein Fehler aufgetreten.');
                });
            }).catch((err) => {
                toast('Es ist ein Fehler aufgetreten.');
            }).always(() => {
                loader.hide()
            })
            /*
            console.log(this.profile.files);
            this.files.push({
                name: input_file.name,
                size: '0.8MB',
                created: '16.08.2018',
            });
            */
        },
        show_file(file) {
            if (!file) return;
            var name = file.name,
                file_url = (file.file) ? file.file.url() : null;
            if (!name || !file_url) {
                return;
            }
            var link = document.createElement('a')
            //link.setAttribute('download', name);
            link.setAttribute('target', '_blank');
            link.setAttribute('href', file_url);
            link.click();
        },
        get_file_url(file) {
            if (file) {
                var file_url = (file.file) ? file.file.url() : null;
                return file_url;
            }
            return '#';
        },
        upload_image() {
            var files = this.$refs.image.files;
            if (!files || !files.length) {
                return;
            }
            var input_file = files[0];
            if (!input_file || !input_file.name) {
                return;
            }

            let loader = this.$loading.show();
            var file = ParseFile(input_file);
            file.$save().then((file) => {
                this.profile.$p.addUnique('images', file);
                this.profile.$save().then((profile) => {
                    this.profile = profile;
                    var files = profile.$p.get('images') || [];
                    this.images = files.map((f) => ParseFile(f), files);
                });
            }).finally(() => {
                loader.hide();
            });
        },

        delete_image(filesObj) {
            const finalObjs = this.images.filter(item => item != filesObj);

            this.profile.$p.set("images", finalObjs);
            this.profile.$save()
            // reload images array
            var files = this.profile.$p.get('images') || [];
            this.images = files.map((f) => ParseFile(f), files);
        },

        delete_file(filesObj, evt) {
            evt.preventDefault();
            const finalObjs = this.files.filter(item => item != filesObj);

            this.profile.$p.set("files", finalObjs);
            this.profile.$save()
            // reload images array
            var files = this.profile.$p.get('files') || [];
            this.files = files.map((f) => ParseFile(f), files);
            return;
        },

        upload_profile_image() {
            var files = this.$refs.profile_image.files;
            if (!files || !files.length) {
                return;
            }
            var input_file = files[0];
            if (!input_file || !input_file.name) {
                return;
            }

            var file = ParseFile(input_file);
            let loader = this.$loading.show();
            file.$save().then((file) => {
                this.profile.$p.set('profile_image', file);
                this.profile.$save().then((profile) => {
                    this.profile = profile;
                    var file = profile.$p.get('profile_image') || false;
                    this.profile_image = ParseFile(file);
                }).catch((err) => {
                    toast(
                            'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
                        );
                });
            }).catch((err) => {
                toast(
                        'Ein Fehler ist aufgetreten. Bitte versuchen Sie es erneut.'
                    );
            }).always(() => {
                loader.hide();
            });
        },

        send_request() {
            this.$modal.close('send_request');
            var me = this.$shared.user.profile,
                type = this.$shared.user.type;
            if (!me) {
                return;
            }

            var data1 = {
                to: this.profile.objectId,
                to_type: this.module,    
                title: 'Bewerberportal MV - Neue Anfrage von ' + me.name,
                content: 'Sie haben im Bewerberportal eine neue Anfrage erhalten. Hier gehts zum Profil:',
                link: '/' + (type == 'Employer' ? 'employers' : 'applicants') + '/' + me.objectId,
            };

            var data2 = {
                to: me.objectId,
                to_type: this.module == "employers" ? "applicants" : "employers",    
                title: 'Bewerberportal MV - Anfrage gesendet an ' + this.profile.name,
                content: 'Sie haben folgendem Nutzer eine Anfrage gesendet:',
                link: '/' + (type != 'Employer' ? 'employers' : 'applicants') + '/' + this.profile.objectId,
            };

            var connection = {
                applicant: this.module == "employers" ? me.objectId : this.profile.objectId,
                employer: this.module != "employers" ? me.objectId : this.profile.objectId
            }
            let loader = this.$loading.show();

            Parse.Cloud.run('connect', connection).then((result) => {
                var notif1 = Parse.Cloud.run('create_notification', data1);
                var notif2 = Parse.Cloud.run('create_notification', data2);

                Parse.Promise.all([notif1, notif2]).then(() => {
                    toast('Ihre Anfrage wurde versendet.');
                    this.alreadySent = true;
                    Parse.User.current().fetch();
                }).catch(() => {
                    toast('Ein Fehler ist aufgetreten. Bitte wenden Sie sich an den Administrator.');
                });
            }).always(() => {
                loader.hide();
            });
        },
        save_content() {
            this.$modal.close('content_editor');
            //this.profile.description = '' + this.editor.description;
            this.profile.$p.set('description', '' + this.editor.description);
            this.profile.$save().then((profile) => {
                this.profile = profile;
                toast('Das Profil wurde aktualisiert.');

                if (this.profile) {
                    // fill content editor fields
                    this.editor.description = this.profile.$p.get('description');
                }
            }).catch((err) => {
                toast('Es ist ein Fehler aufgetreten.');
            });
        },
        format_filesize(bytes) {
            // https://gist.github.com/lanqy/5193417
            var sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB'];
            if (bytes == 0) return 'n/a';
            var i = parseInt(Math.floor(Math.log(bytes) / Math.log(1024)));
            if (i == 0) return bytes + ' ' + sizes[i];
            return (bytes / Math.pow(1024, i)).toFixed(1) + ' ' + sizes[i];
        },

        edit_profile() {
            this.edit_address.name = this.$options.filters.formatAddress(this.profile.address);
            this.edit_address.obj = this.profile.address;
            this.edit_address.position = this.profile.position;
            this.edited_profile = _.clone(this.profile, true);
            this.$modal.show('profile_editor');
        },

        save_profile() {
            this.$modal.close('profile_editor');

            this.profile.$p.set('name', this.edited_profile.name);
            this.profile.$p.set('mail', this.edited_profile.mail);
            this.profile.$p.set('phone', this.edited_profile.phone);
            this.profile.$p.set('position', new Parse.GeoPoint(this.edit_address.position));
            this.profile.$p.set('address', this.edit_address.obj);

            let loader = this.$loading.show();

            this.profile.$save().then((profile) => {
                this.profile = profile;
                toast('Das Profil wurde aktualisiert.');
            }).catch((err) => {
                toast('Es ist ein Fehler aufgetreten.');
            }).always(() => {
                loader.hide();
            });
        },
        remove_profile() {
            console.log(this.profile.className);
            var profileParams = {
                this_user: this.profile.objectId,
                this_type: this.profile.className,
            };
            if (confirm('Soll dieses Profil gelöscht werden?')) {
                
                Parse.Cloud.run('delete_user', profileParams).then((result) => {
                    if (result) {
                        if (this.$shared.user.profile.admin) {
                            toast('Das Nutzerprofil wurde gelöscht!');
                            this.$router.push('/');
                        } else {
                            toast('Ihr Profil wurde gelöscht. Auf Wiedersehen!');
                            this.$router.push('/logout');
                        }
                    } else {
                        toast(
                            'Ein Fehler ist aufgetreten. Bitte wenden Sie sich an den Administrator.'
                        );
                    }
                }).catch(() => {
                    toast(
                        'Ein Fehler ist aufgetreten. Bitte wenden Sie sich an den Administrator.'
                    );
                });
            }
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/components/profile.vue